export const awsMarketplaceTokenStorageKey = "aws_marketplace_token";
export const awsTokenQueryKey = "x-amzn-marketplace-token";
export const awsMarketplaceSubscriptionListingCode = "4i7x5vj2qm9kge4gwf54jebmq";
